import styled from '@emotion/styled';
import { Divider } from '@mui/material';

export const StyledDivider = styled(Divider)`
    margin: 1rem 0;
    margin-right: 20px;
`;
